module.exports = "";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/splash/splash.html
 ** module id = 323
 ** module chunks = 0
 **/